export const ORDERS_BLOTTER_PREFIX = 'principal/orders';
export const BLOTTER_ID_OPEN_ORDERS = `${ORDERS_BLOTTER_PREFIX}/open-orders`;
export const ORDER_SUB_THROTTLE = '100ms';
